module.exports = __webpack_public_path__ + "static/media/Logo.6cc57ee3.png";